/**
 * Returns an optimized (reduced) image (uses WP Image Resizer)
 *
 * usage examples:
 * imageHelpers.wpresizer([360, 240], imageSrc)
 * or
 * imageHelpers.wpresizer({ratio: ImageRatio['16/9'], size: ImageSize.Sm}, imageSrc)
 */

import { IMAGE_SIZES } from '../consts';
import { ImageRatio, ImageSize } from '../enums';

type ImageSizeObject = {
    ratio: ImageRatio;
    size: ImageSize;
};

export type WpResizerFn = (size: [number, number] | ImageSizeObject, url: string) => string;

export const WP_RESIZER_ORIGIN = 'https://i.wpimg.pl';

/**
 * Core helper: builds a wpresizer URL with an optional multiplier.
 * Returns: https://i.wpimg.pl/{width}x{height}/{imageUrl}
 */
export const buildWpResizerUrl = (
    size: [number, number] | ImageSizeObject,
    url: string,
    multiplier?: number,
): string => {
    const imageUrl = url.replace(/^https?:\/\//, '');
    let w;
    let h;

    if (Array.isArray(size)) {
        w = size[0];
        h = size[1];
    } else {
        w = IMAGE_SIZES[size.ratio][size.size].width;
        h = IMAGE_SIZES[size.ratio][size.size].height;
    }

    if (multiplier !== undefined) {
        const m = Math.max(Number(multiplier) || 1, 1);
        w = Math.round(w * m);
        h = Math.round(h * m);
    }

    return `${WP_RESIZER_ORIGIN}/${w}x${h}/${imageUrl}`;
};

export const wpresizer: WpResizerFn = (size, url) => buildWpResizerUrl(size, url);
